import {
  mdiDeleteOutline,
  mdiInformationSlabCircleOutline,
  mdiPencilOutline,
  mdiPlus
} from '@mdi/js';
import type { EventLogEntityType, EventLogEntry } from 'api/models/api';
import type { AuditEventType } from 'common/models';

const getReferenceId = (event: EventLogEntry, entityType: EventLogEntityType) =>
  event.references.find((reference) => reference.entityType === entityType)?.entityId;

// Complexity is too hight because of conditions
export const getEventLink = (event: EventLogEntry) => {
  if (event.headlineType === 'Customer') {
    return `/customers/${event.headlineId}`;
  }

  if (event.headlineType === 'ServiceObject') {
    return `/customers/${getReferenceId(event, 'Customer')}/serviceObjects/${event.headlineId}`;
  }

  if (event.headlineType === 'Order') {
    return `/orders/${event.headlineId}`;
  }

  if (event.headlineType === 'Intervention') {
    return `/orders/${getReferenceId(event, 'Order')}/interventions/${event.headlineId}`;
  }

  if (event.headlineType === 'User') {
    return `/settings/users/${event.headlineId}`;
  }

  return undefined;
};

export const getEventIcon = (type: AuditEventType) => {
  if (type.startsWith('Add')) {
    return {
      icon: mdiPlus,
      className: 'green'
    };
  }

  if (type.startsWith('Edit')) {
    return {
      icon: mdiPencilOutline,
      className: 'orange'
    };
  }

  if (type.startsWith('Delete')) {
    return {
      icon: mdiDeleteOutline,
      className: 'red'
    };
  }

  return {
    icon: mdiInformationSlabCircleOutline,
    className: 'gray'
  };
};
